var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06755 18.9518C1.30374 18.9518 1.54936 18.8668 1.85168 18.6967L6.66038 16.1082L11.8848 19.0368C12.2248 19.2258 12.5933 19.3203 12.9429 19.3203C13.2735 19.3203 13.6042 19.2353 13.8876 19.0747L18.8286 16.2688C19.3954 15.957 19.6505 15.5036 19.6505 14.8706V2.145C19.6505 1.4459 19.2631 1.05856 18.5829 1.05856C18.3467 1.05856 18.1011 1.13414 17.7894 1.30419L12.7823 4.09115L7.65235 0.94519C7.35948 0.775137 7.02882 0.680664 6.69817 0.680664C6.35807 0.680664 6.01796 0.775137 5.72509 0.94519L0.812472 3.7416C0.255078 4.06281 0 4.51628 0 5.14926V17.8559C0 18.5551 0.387341 18.9518 1.06755 18.9518ZM6.0463 14.606L1.78554 16.949C1.73832 16.9678 1.69108 16.9962 1.64384 16.9962C1.56826 16.9962 1.52103 16.9395 1.52103 16.8451V5.5177C1.52103 5.29096 1.60605 5.13036 1.83278 4.9981L5.7062 2.73074C5.82901 2.6646 5.93293 2.60792 6.0463 2.54179V14.606ZM7.56733 14.7572V2.74019C7.66179 2.79687 7.77517 2.85355 7.86964 2.91024L12.0831 5.47992V17.2891C11.9509 17.2135 11.8091 17.1474 11.6674 17.0718L7.56733 14.7572ZM13.6042 17.4592V5.38544L17.8649 3.0614C17.9121 3.03305 17.9594 3.01416 17.9972 3.01416C18.0822 3.01416 18.1294 3.07084 18.1294 3.16532V14.4926C18.1294 14.7289 18.035 14.8895 17.8177 15.0217L14.0294 17.223C13.8876 17.308 13.7459 17.393 13.6042 17.4592Z",
    fill: "#EA6C52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.af1ec472d144f1b64207f354e2026b49.svg";
export { ForwardRef as ReactComponent };